import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import CreditEditConfirmModel from './CreditEditConfirmModel';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CreditEditBalanceModel = ({ show, onClose, handleCreditUpdate, creditData, modelMode }) => {
  const { user_name, email, available_balance, symbol, role, id, alert_balance } = creditData;
  const [amount, setAmount] = useState('');
  const [update_operation, setUpdateOperation] = useState('topup');
  const [currentBalance, setCurrentBalance] = useState(available_balance || 0);
  const [alertBalance, setAlertBalance] = useState(alert_balance || 0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [confirmationData, setConfirmationData] = useState(null);

  const openModal = () => {
    if (modelMode === 'balance_alert') setUpdateOperation('alert_balance');
    if (!amount) return setAlertMessage('Please enter a valid amount...');
    if (update_operation === 'deduct' && available_balance < parseFloat(amount))
      return setAlertMessage('Insufficient balance to deduct');

    setConfirmationData(creditData);
    setShowConfirmation(true);
    onClose();
  };

  const closeModal = () => {
    setAmount('');
    onClose();
    setShowConfirmation(false);
  };

  const handleSubmit = () => {
    const amountValue = parseFloat(amount);

    if (update_operation === 'topup') setCurrentBalance((prevBalance) => prevBalance + amountValue);
    if (update_operation === 'deduct')
      setCurrentBalance((prevBalance) => prevBalance - amountValue);
    if (update_operation === 'alert_balance') setCurrentBalance(amountValue);

    handleCreditUpdate(id, amountValue, update_operation);
    setAlertMessage('');
    setAmount('');
    setShowConfirmation(false);
  };

  useEffect(() => {
    if (creditData) {
      setAlertMessage('');
      setCurrentBalance(available_balance || 0);
      setAlertBalance(alert_balance || 0);
    }
  }, [creditData]);

  useEffect(() => {
    if (!amount) return setAlertMessage('');

    if (modelMode === 'balance_alert')
      return setAlertMessage(amount ? `New Credit Balance Alert ${amount}` : '');

    const amountValue = parseFloat(amount);
    var newBalance;
    if (update_operation === 'topup') newBalance = available_balance + amountValue;
    if (update_operation === 'deduct') newBalance = available_balance - amountValue;

    var message;
    if (white_label_perkeso) message = `New Credit Balance ${newBalance}`;
    if (!white_label_perkeso) message = `New Credit Balance ${symbol} ${newBalance}`;
    setAlertMessage(message);
  }, [amount, update_operation, available_balance, modelMode, symbol, white_label_perkeso]);

  return (
    <>
      <Modal className="modal-edit" show={show} onHide={onClose} animation centered>
        <Modal.Body>
          <CloseIcon handleModalClose={onClose} />
          <Modal.Title as="h4" className="mb-3">
            {modelMode === 'balance_alert' ? 'Edit Credit Balance Alert' : 'Edit Credit Balance'}
          </Modal.Title>
          <p>
            <strong>User ID:</strong> {id}
          </p>
          <p>
            <strong>Name:</strong> {user_name}
          </p>
          <p>
            <strong>Email:</strong> {email}
          </p>
          {white_label_perkeso && (
            <p>
              <strong>Role:</strong> {role}
            </p>
          )}
          {modelMode === 'balance' && (
            <p>
              <strong>Current Credit Balance:</strong> {currentBalance}
            </p>
          )}
          {modelMode === 'balance_alert' && (
            <p>
              <strong>Current Credit Balance Alert:</strong> {alertBalance}
            </p>
          )}

          <Form.Group controlId="formMode">
            <Form.Label>
              {modelMode === 'balance_alert' ? 'Credit Balance Alert' : 'Credit Amount'}
            </Form.Label>
            <div className="mb-4">
              {modelMode === 'balance' ? (
                <>
                  <Form.Check
                    type="radio"
                    label="Add Credit"
                    name="update_operation"
                    id="addCredit"
                    checked={update_operation === 'topup'}
                    onChange={() => setUpdateOperation('topup')}
                  />
                  {update_operation === 'topup' && (
                    <Form.Control
                      type="number"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="mt-2"
                    />
                  )}
                  <Form.Check
                    type="radio"
                    label="Deduct Credit"
                    name="update_operation"
                    id="deductCredit"
                    checked={update_operation === 'deduct'}
                    onChange={() => setUpdateOperation('deduct')}
                    className="mt-3"
                  />
                  {update_operation === 'deduct' && (
                    <Form.Control
                      type="number"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="mt-2"
                    />
                  )}
                </>
              ) : (
                <Form.Control
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="mt-2"
                />
              )}
            </div>
            {alertMessage && (
              <Form.Text
                style={{
                  backgroundColor:
                    alertMessage === 'Please enter a valid amount...' ? '#f8d7da' : '#d4edda',
                  color: alertMessage === 'Please enter a valid amount...' ? 'red' : 'black',
                  padding: '10px',
                  borderRadius: '5px',
                  display: 'block',
                  marginBottom: '10px',
                  fontSize: '14px',
                }}
              >
                {alertMessage}
              </Form.Text>
            )}
          </Form.Group>
          <div className="d-flex justify-content-left mt-3 gap-3">
            <Button variant="primary" onClick={openModal} style={{ minWidth: '160px' }}>
              Update
            </Button>
            <Button variant="ghost" onClick={closeModal} style={{ minWidth: '160px' }}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <CreditEditConfirmModel
        show={showConfirmation}
        onClose={closeModal}
        creditData={confirmationData}
        onConfirm={handleSubmit}
        update_operation={update_operation}
        amount={amount}
        modelMode={modelMode}
      />
    </>
  );
};

export default CreditEditBalanceModel;
